import React, { useRef, useState, useEffect } from "react";
import { Row, Col, Table, Spin, Select, DatePicker, Space, Form } from "antd";
import Button from "atoms/Button";
import moment from "moment";
import styled from "@emotion/styled";
import { CSVLink } from "react-csv";
import { connect } from "react-redux";
import {
  getUserRoleId,
  getAllDepartmentList,
  getSelectedDepartmentId,
  getShiftTimeMaster,
  getUserList,
  getClientid,
  getUserInfo,
  getMenuList,
} from "redux/selectors";
import { utils, writeFileXLSX } from "xlsx";
import { CALL_API } from "common/API";
import { MONTH_LIST, STATUS_CODE, countryList } from "common/Constants";

import {
  addDaysinDate,
  dateInDetail,
  getKenyanDateTime,
  getMonthDateRange,
  getMySqlDate,
  momentDate,
  numberOfDaysBetweenDates,
} from "utils/Date";
import COLORS from "common/Colors";
import {
  concat,
  find,
  get,
  includes,
  orderBy,
  flatMap,
  intersection,
  uniqBy,
} from "lodash";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";

const StyledTable = styled(Table)`
  padding-top: 20px;
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
  }
  table {
    width: 100% !important;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .non-white {
    background: #f9f9f9;
  }
`;

const StyledApprovalSearchForm = styled(Form)`
  .ant-form-item-with-help {
    margin-bottom: 0px;
    .ant-form-item-explain-connected {
      display: none;
    }
  }
  .ant-form-item {
    display: inline-block;
  }
  .outer-form {
    margin-right: 0px;
  }
  .ant-select-selector {
    max-width: 180px;
    min-width: 180px;
    margin-bottom: 10px;
    width: 180px;
  }
  .ant-btn.ant-btn-default.ant-dropdown-trigger.w-100.mb-3.custom-filter-btn {
    width: 180px !important;
  }
`;
const StyledButtonoutlined = styled(ButtonOutlined)`
  @media (max-width: 900px) {
    margin-left: -20px !important;
  }
  @media (max-width: 768px) {
    margin-left: -20px !important;
    margin-top: -1px !important;
  }
  @media (max-width: 575px) {
    margin-left: 0 !important;
    position: absolute;
    left: 0;
    margin-top: -1px;
  }
`;
function MonthlyAttendanceReport({
  userRoleId,
  allDepartmentList,
  selectedDepartmentId,
  ClientId,
  userList,
  userInfo,
  menuList, // Added menuList
}) {
  const higherOfficialsEmailId = userInfo?.higherOfficialsList?.map(
    (val) => val?.email
  );
  const [displayTableLoader, setDisplayTableLoader] = useState(false);
  const [attendanceList, setAttendanceList] = useState([]);
  const [CSVAttendanceList, setCSVAttendanceList] = useState([]);
  const [form] = Form.useForm();
  const csvLinkEl = useRef();
  var filterList = [];
  const [monthList, setMonthList] = useState([]);
  const containerRef = useRef(null);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [employeeFilterList, setEmployeeFilterList] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [countryFilterList, setCountryFilterList] = useState([]);
  const [filteredUserIds, setFilteredUserIds] = useState([]);
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [getFilterData, setGetFilterData] = useState([]);

  const curr_month = moment().month() + 1;

  const list = () => {
    let month_list = [];
    for (let i = 0; i < curr_month; i++) {
      month_list.push(MONTH_LIST[i]);
    }
    setMonthList(month_list);
  };

  const STAFF_LIST_ALL = attendanceList.map((val) => {
    return { userId: val.userId, fullName: val.fullName };
  });

  for (let i = 0; i < STAFF_LIST_ALL.length; i++) {
    filterList.push(STAFF_LIST_ALL[i]);
  }

  const STAFF_LIST = [...new Set(filterList.map((a) => JSON.stringify(a)))].map(
    (a) => JSON.parse(a)
  );

  const filterattentancereport = attendanceList.filter((val) => {
    const selectedEmployeeIds = form.getFieldValue("employee") || [];
    const selectedCountries = form.getFieldValue("country") || [];
    const employeeMatch =
      selectedEmployeeIds.length === 0 ||
      selectedEmployeeIds.includes(val.userid);

    // Check if the country matches the selected countries
    const countryMatch =
      selectedCountries.length === 0 ||
      selectedCountries.includes(
        userList.find((user) => user.userid === val.userid)?.nationality
      );

    return employeeMatch && countryMatch;
  });

  const [holidayList, setHolidayList] = useState([]);

  const calculateSundays = (startDate, endDate) => {
    const start = moment(startDate);
    const end = moment(endDate);

    let sundays = 0;
    let currentDay = start.clone();

    while (currentDay.isSameOrBefore(end, "day")) {
      if (currentDay.day() === 0) {
        sundays++;
      }
      currentDay.add(1, "day");
    }

    return sundays;
  };

  const workingdays = async (startDate, endDate, userId, holidayLists) => {
    const totalDay = numberOfDaysBetweenDates(startDate, endDate) + 1;
    const filterUser = userList?.filter((val) => val?.userid === userId);
    const holidayPerUser = holidayLists?.filter((item) =>
      item?.location_id?.includes(filterUser[0]?.baselocationid)
    );
    const weekendShiftUser = filterUser[0]?.weekendShift || {};

    let totalHolidays = 0;
    holidayPerUser.forEach((holiday) => {
      const removeWeekends = calculateWeekends(
        holiday.start_date,
        holiday.end_date,
        weekendShiftUser
      );
      totalHolidays +=
        numberOfDaysBetweenDates(holiday.start_date, holiday.end_date) +
        1 -
        removeWeekends;
    });
    console.log("totalHolidays121---->", totalHolidays)
    console.log("holidayPerUser---->", holidayPerUser)
    const weekendCount = calculateWeekends(startDate, endDate, weekendShiftUser);
    return totalDay - (weekendCount + totalHolidays);
  };

  const calculateWeekends = (start, end, weekendShiftUser) => {
    let weekendCount = 0;
    let totalWeekendCount = 0;
    const startDate = new Date(start);
    const endDate = new Date(end);
    let currentDate = new Date(startDate); // ← proper clone for looping

    const isSaturdayNotApplicable =
      weekendShiftUser?.saturdayEnabled === true &&
      weekendShiftUser?.notApplicable === false;

    const isSundayNotApplicable =
      weekendShiftUser?.sundayEnabled === true &&
      weekendShiftUser?.notApplicable === false;

    // console.log("isSaturdayNotApplicable121--->", isSaturdayNotApplicable);
    // console.log("isSundayNotApplicable121--->", isSundayNotApplicable);

    while (currentDate <= endDate) {
      const dayOfWeek = currentDate.getDay(); // 0 = Sunday, 6 = Saturday

      if (dayOfWeek === 6) { // Saturday
        if (isSaturdayNotApplicable) {
          if (weekendShiftUser?.saturdayType === "halfday") {
            // console.log("Saturday halfday --->", currentDate);
            weekendCount += 0.5;
          } else if (weekendShiftUser?.saturdayType === "fullday") {
            // console.log("Saturday fullday --->", currentDate);
            weekendCount += 1;
          }
        }
        totalWeekendCount++;
      }

      else if (dayOfWeek === 0) { // Sunday
        if (isSundayNotApplicable) {
          if (weekendShiftUser?.sundayType === "halfday") {
            // console.log("Sunday halfday --->", currentDate);
            weekendCount += 0.5;
          } else if (weekendShiftUser?.sundayType === "fullday") {
            // console.log("Sunday fullday --->", currentDate);
            weekendCount += 1;
          }
        }
        totalWeekendCount++;
      }

      // Safely move to the next day
      currentDate.setDate(currentDate.getDate() + 1);
    }

    // console.log("weekendCount121--->", weekendCount);
    // console.log("okayData121---->", totalWeekendCount);

    return totalWeekendCount - weekendCount;
  };

  const CSVHeaders = [
    { label: "Employee ID" },
    { label: "User ID" },
    { label: "First Name" },
    { label: "Last Name" },
    { label: "Total Working Days" },
    { label: "Worked days" },
    { label: "On-time" },
    { label: "Late" },
    { label: "Leave" },
    { label: "Absent" },
  ];

  const columns = [
    {
      title: "Employee ID",
      dataIndex: "employeeid",
      key: "employeeid",
      width: "7%",
    },
    {
      title: "User ID",
      dataIndex: "userid",
      key: "userid",
      width: "7%",
      render: (userid) => {
        if (userid !== ("" || null || undefined)) {
          return userid;
        } else {
          return "-";
        }
      },
    },
    {
      title: "Name",
      dataIndex: "fullname",
      key: "fullname",
      width: "10%",
      render: (fullname) => {
        if (fullname !== ("" || null || undefined)) {
          return fullname;
        } else {
          return "-";
        }
      },
    },
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
      width: "10%",
      render: (country, record) => {
        if (country) {
          return country;
        } else {
          return (
            userList.find((user) => user.userid === record.userid)
              ?.nationality || "-"
          );
        }
      },
    },
    {
      title: "Total Working days",
      dataIndex: "totalWorkingDays",
      key: "totalWorkingDays",
      width: "10%",
    },
    {
      title: "Worked days",
      dataIndex: "workingDays",
      key: "workingDays",
      width: "10%",
      render: (_, record) => {
        return record.ontimecount + record.latecount;
      },
    },

    {
      title: "On-Time",
      dataIndex: "ontimecount",
      key: "ontimecount",
      width: "10%",
      render: (onTimeCount) => {
        if (onTimeCount === ("" || null || undefined)) {
          return "0";
        } else {
          return onTimeCount;
        }
      },
    },
    {
      title: "Late",
      dataIndex: "latecount",
      key: "latecount",
      width: "10%",
      render: (lateCount) => {
        if (lateCount === ("" || null || undefined)) {
          return "0";
        } else {
          return lateCount;
        }
      },
    },

    {
      title: "Leave",
      dataIndex: "leavecount",
      key: "leavecount",
      width: "10%",
      render: (leaveCount) => {
        if (
          leaveCount === "" ||
          leaveCount === null ||
          leaveCount === undefined
        ) {
          return "0";
        } else {
          const num = parseFloat(leaveCount);
          return Number.isInteger(num) ? num.toString() : num.toFixed(1);
        }
      },
    },

    {
      title: "Absent",
      dataIndex: "absentcount",
      key: "absentcount",
      width: "10%",
      render: (absentCount) => {
        if (absentCount === ("" || null || undefined)) {
          return "0";
        } else {
          return absentCount;
        }
      },
    },
  ];

  useEffect(() => {
    getAttendanceReport();
  }, [
    selectedDepartmentId,
    selectedCountries,
    userRoleId,
    form.getFieldValue("duration_type"),
    form.getFieldValue("start_date"),
    form.getFieldValue("end_date"),
    form.getFieldValue("month"),
    form.getFieldValue("department"),
  ]);
  const isChairman = userInfo.higherOfficialsList.some(
    (official) =>
      official.role === "CHAIRMAN" && official.email === userInfo.userid
  );
  const getAttendanceReport = async () => {
    list();
    setAttendanceList([]);
    const { month, department } = form.getFieldsValue();
    setDisplayTableLoader(true);

    const { startDateOfMonth, lastDateOfMonth } = getMonthDateRange(
      dateInDetail(getKenyanDateTime()).year,
      get(find(MONTH_LIST, { value: month }), "index", 0)
    );

    const holidayLists = await CALL_API(`holiday-list/${ClientId}`, "post", {
      start_date: getMySqlDate(startDateOfMonth),
      end_date: getMySqlDate(lastDateOfMonth),
    });

    if (holidayLists) {
      setHolidayList(holidayLists);
    }
    const emailList = userInfo.higherOfficialsList.map((official) =>
      official.email.toLowerCase()
    );

    // Check if the user is in the higher officials list
    const isPrivilegedUser = emailList.includes(userInfo.userid.toLowerCase());

    const isHigherOfficial = higherOfficialsEmailId?.includes(userInfo?.userid);

    const payload = {
      departmentId: [""],
      startDate: getMySqlDate(startDateOfMonth),
      endDate: getMySqlDate(lastDateOfMonth),
      reportingmanager: isChairman
        ? ""
        : isPrivilegedUser
        ? ""
        : userInfo?.userid,
      userIds: isChairman ? [] : isPrivilegedUser ? userId : filteredUserIds,
    };

    const { code, monthlyAttendanceList } = await CALL_API(
      `attendance-report-monthly/${ClientId}`,
      "post",
      payload
    );

    if (includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)) {
      const userIdExistsInData1 = (userId) => {
        if (!userId) return false;
        return monthlyAttendanceList?.some(
          (item) => item?.userid?.toLowerCase() === userId.toLowerCase()
        );
      };

      const filteredUserList = userList?.filter((item) => {
        const userId = item?.userid?.toLowerCase();
        const isValid =
          userId &&
          item?.statusid === "1" &&
          !userIdExistsInData1(userId) &&
          (isHigherOfficial || item?.reportingmanager === userInfo?.userid);
        return isValid;
      });
      // const allUserList = userList
      //   ?.filter((item) => {
      //     const userId = item?.userid?.toLowerCase();
      //     if (isChairman) {
      //       return userId && !userIdExistsInData1(userId);
      //     } else {
      //       return (
      //         userId &&
      //         !userIdExistsInData1(userId) &&
      //         item?.reportingmanager === userInfo?.userid
      //       );
      //     }
      //   })
      //   .map((item) => ({
      //     employeeid: item?.employeeid,
      //     latecount: 0,
      //     monthenddate: getMySqlDate(lastDateOfMonth),
      //     leavecount: 0,
      //     userid: item?.userid,
      //     monthstartdate: getMySqlDate(startDateOfMonth),
      //     absentcount: 0,
      //     earlycheckoutcount: 0,
      //     fullname: item?.fullname,
      //     ontimecount: 0,
      //     country: item?.nationality,
      //   }));
      const allUserList = filteredUserList?.map((item) => ({
        employeeid: item?.employeeid,
        latecount: 0,
        monthenddate: getMySqlDate(lastDateOfMonth),
        leavecount: 0,
        userid: item?.userid,
        monthstartdate: getMySqlDate(startDateOfMonth),
        absentcount: 0,
        earlycheckoutcount: 0,
        fullname: item?.fullname,
        ontimecount: 0,
      }));

      const monthlyAttendanceReport = concat(
        monthlyAttendanceList,
        allUserList
      );

      await Promise.all(
        monthlyAttendanceReport?.map(async (entry) => {
          const filterUser = userList?.filter(
            (val) => val?.userid === entry?.userid
          );
          const concatenatedArray = flatMap(filterUser[0]?.userdepartmentid);
          const totalWorkingDays = await workingdays(
            entry.monthstartdate,
            entry.monthenddate,
            entry.userid,
            holidayLists
          );
          entry.totalWorkingDays = totalWorkingDays;
          if (
            intersection(concatenatedArray, selectedDepartmentId).length > 0
          ) {
            return entry;
          } else {
            return null;
          }
        })
      );

      setAttendanceList(monthlyAttendanceReport);
    }
    setDisplayTableLoader(false);
  };

  const validateDateRange = (date) => {
    const endDate = moment(form.getFieldValue("end_date"));
    if (endDate < date) {
      form.setFieldsValue({ end_date: date });
    }
  };

  const paginationOptions = {
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSize: 100,
    showSizeChanger: false,
  };

  const xport = React.useCallback(() => {
    const elt = document.getElementById("Table");
    const wb = utils.table_to_book(elt);
    writeFileXLSX(wb, "attendance-report.xlsx");
  });

  const handleEmployeeFilterChange = () => {
    const values = form.getFieldsValue();
    setSelectedEmployees(values.employee || []);
  };
  const handleCountryFilterChange = () => {
    const values = form.getFieldsValue();
    setFilteredCountries(values.country || []);
  };
  useEffect(() => {
    if (filteredCountries.length === 0) {
      setFilteredUserIds([]); // Reset if no filter is selected
      setCountryFilterList(attendanceList); // Reset table data to the full list
      return;
    }

    // Filter users based on selected countries
    const filteredUsers = userList.filter((user) =>
      filteredCountries.some((country) => user.nationality === country)
    );

    const userIds =
      filteredUsers.map((user) => user.userid || user.userId) || [];
    setFilteredUserIds(userIds);

    // Filter the attendance list based on the filtered user IDs
    const filteredData = attendanceList.filter((item) =>
      userIds.includes(item.userid)
    );
    setCountryFilterList(filteredData); // Update the table data source
  }, [filteredCountries, attendanceList, userList]);
  // API Call (Ensure it happens after filteredUserIds updates)
  useEffect(() => {
    if (filteredUserIds.length > 0) {
      // getAttendanceReport();
    }
  }, [filteredUserIds]);

  const uniqueEmployeeName = uniqBy(
    attendanceList
      ?.map((item) => {
        const user = userList.find((user) => user.userid === item.userid);
        if (user && user.fullname && user.userid) {
          return {
            label: user.fullname.toString(), // Ensure label is a string
            value: user.userid.toString(), // Ensure value is a string
          };
        }
        return null; // Filter out invalid entries
      })
      .filter(Boolean), // Remove null or undefined entries
    "value"
  );
  const uniqueCountryName = uniqBy(
    userList
      ?.filter((user) =>
        attendanceList.some((attendance) => attendance.userid === user.userid)
      )
      ?.map((user) => ({
        label: user.nationality,
        value: user.nationality,
      })),
    "value"
  );

  const Menulist = menuList[userRoleId] || Object.values(menuList)[0]; // Added Menulist logic

  const finduser = userList?.find((val) => val?.userid === userInfo?.userid);
  const nationality = finduser?.nationality;
  const userId = userList
    .filter((user) => user.nationality?.includes(nationality))
    .map((user) => user.userid);
  return (
    <>
      <Row className="page-title">
        <Col
          xs={24}
          sm={19}
          md={19}
          className="page-title-head"
          ref={containerRef}
        >
          <Space>
            <StyledApprovalSearchForm
              form={form}
              name="approval_form"
              layout="inline"
              initialValues={{
                staff_name: "",
                duration_type: 2,
                month: dateInDetail(getKenyanDateTime()).monthName,
                start_date: momentDate(getKenyanDateTime()),
                end_date: momentDate(addDaysinDate(getKenyanDateTime(), 7)),
                department: "",
                country: [],
              }}
              onFinish={getAttendanceReport}
              onValuesChange={(changedValues) => {
                if (changedValues.country) {
                  handleCountryFilterChange(); // Update the filteredCountries state
                } else {
                  handleEmployeeFilterChange(); // Handle other form changes
                  getAttendanceReport(); // Call the API for other changes
                }
              }}
            >
              <Form.Item className="outer-form" shouldUpdate>
                {({ getFieldValue }) => {
                  const duration_type = getFieldValue("duration_type");
                  return duration_type === 1 ? (
                    <>
                      <Form.Item
                        name="start_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder="Start date"
                          format="DD-MM-YYYY"
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>

                      <Form.Item
                        name="end_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder="End date"
                          format="DD-MM-YYYY"
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </>
                  ) : (
                    <>
                      <Form.Item
                        name="month"
                        rules={[
                          {
                            required: true,
                            message: "",
                          },
                        ]}
                      >
                        <Select
                          className="custom_form_design"
                          placeholder="Select..."
                          options={monthList}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </>
                  );
                }}
              </Form.Item>
              <Form.Item
                name="staff_name"
                rules={[
                  {
                    required: false,
                    message: "",
                  },
                ]}
              >
                {/* Ensure this block is properly closed */}
              </Form.Item>
              <Form.Item name="employee">
                <DropdownCheckBox
                  name="employee"
                  label="All Employee"
                  options={uniqueEmployeeName}
                  form={form}
                  handleFormChange={(selectedValues = []) => {
                    // Ensure selectedValues is always an array
                    if (selectedValues.includes("all")) {
                      // Select all values
                      const allValues = uniqueEmployeeName.map(
                        (option) => option.value
                      );
                      form.setFieldsValue({ employee: allValues });
                    } else {
                      handleEmployeeFilterChange();
                    }
                  }}
                  allowClear={true}
                />
              </Form.Item>
              {isChairman && (
                <Form.Item name="country">
                  <DropdownCheckBox
                    name="country"
                    label="Country"
                    options={uniqueCountryName}
                    form={form}
                    clearFunction={getAttendanceReport}
                    handleFormChange={() => {
                      const values = form.getFieldsValue(); // Get the updated form values // Log the selected country values
                      handleCountryFilterChange(); // Call the handler to update the state
                    }}
                  />
                </Form.Item>
              )}
              {(userRoleId === 1 || userRoleId === 6) && (
                <Form.Item name="department">
                  <Select
                    placeholder="Select Department"
                    options={concat(
                      {
                        department_id: "",
                        department_name: "All Departments",
                      },
                      allDepartmentList
                    )}
                    fieldNames={{
                      label: "department_name",
                      value: "department_id",
                    }}
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              )}
            </StyledApprovalSearchForm>
          </Space>
        </Col>
        <Col xs={24} sm={4} md={4} className="align-right">
          <StyledButtonoutlined
            onClick={xport}
            disabled={filterattentancereport.length === 0}
          >
            Export XLSX file
          </StyledButtonoutlined>
          <CSVLink
            header={CSVHeaders}
            data={CSVAttendanceList}
            filename={"attendance-report.csv"}
            asyncOnClick={true}
            ref={csvLinkEl}
          />
        </Col>
      </Row>
      <br />
      <Spin spinning={displayTableLoader}>
        <StyledTable
          dataSource={filterattentancereport} // Corrected variable name
          columns={columns}
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="employeeId"
          pagination={
            filterattentancereport.length > 100 ? paginationOptions : false // Corrected variable name
          }
          id="Table"
        />
      </Spin>
      {/* <Spin spinning={displayTableLoader}>
        <StyledTable
          dataSource={filterattentancereport}
          columns={columns}
          // Note : First parameter is Needed
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="checkin_id"
          pagination={
            filterattentancereport.length > 100 ? paginationOptions : false
          }
          id="Table"
        />
      </Spin> */}
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  userList: getUserList(state),
  allDepartmentList: getAllDepartmentList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  shiftTimeMaster: getShiftTimeMaster(state),
  ClientId: getClientid(state),
  userInfo: getUserInfo(state),
  menuList: getMenuList(state), // Added menuList
});

export default connect(mapStateToProps, null)(MonthlyAttendanceReport);
